/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ContainerType {
  Document = 'Document',
  Contact = 'Contact',
  Vault = 'Vault',
  Magnet = 'Magnet',
  Stamp = 'Stamp'
}
